/* eslint-disable */
import moment from 'moment';

import {
  PO_CLIENT,
  ASN_CLIENT,
  GRN_CLIENT,
  INTERNATIONAL_INVENTORY_CLIENT,
  ATTACHMENT_CLIENT,
  COMMENTS_CLIENT,
  MDM_ENTITY_CLIENT,
  MDM_TERMS_CONDITIONS_CLIENT,
  MDM_BRANDS_CLIENT,
  MDM_TRANSPORT_CLIENT,
  SALES_ORDER_CLIENT,
  SI_PO_CLIENT,
  SI_GRN_CLIENT,
  CLEAR_TAX_INPUT_CLIENT,
  HISTORY_CLIENT,
  VENDOR_AGREEMENT_CLIENT,
  RO_CLIENT
} from './API_Utils';
import * as Constants from './constants';
import apiConfig from './API_Utils/APIUtil/ApiConfig';
import CallApi from './API_Utils/APIUtil/CallApi';
import getResponse from './API_Utils/APIUtil/ApiClient';
import axios from 'axios';
import { showMessage } from './MessageHook';
import { clearCorrelationId } from './API_Utils/correlationId';
/*
const getConfig = () => {
  try {
    const token = JSON.parse(localStorage.getItem('okta-token-storage'))?.accessToken?.accessToken;
    if (!token) {
      throw new Error('Auth not found');
    }
    const config = {
      baseOptions: {
        headers: { Authorization: `Bearer ${token}` }
      }
    };
    return config;
  } catch (error) {
    console.error('Not auth!');
  }
};
*/

const getPOClient = () => PO_CLIENT;
const getCommentsClient = () => COMMENTS_CLIENT;
const getAttachmentClient = () => ATTACHMENT_CLIENT;
const getASNClient = () => ASN_CLIENT;
const getGRNClient = () => GRN_CLIENT;
const getSalesPOClient = () => SI_PO_CLIENT;
const getSalesOrderClient = () => SALES_ORDER_CLIENT;
const getSoGRNClient = () => SI_GRN_CLIENT;
const getClearTaxInputClient = () => CLEAR_TAX_INPUT_CLIENT;
const getInternationalInventoryClient = () => INTERNATIONAL_INVENTORY_CLIENT;
const getMDMEntityClient = () => MDM_ENTITY_CLIENT;
const getMDMTermsAndConditions = () => MDM_TERMS_CONDITIONS_CLIENT;
const getMDMBrandsClient = () => MDM_BRANDS_CLIENT;
const getMDMTransportClient = () => MDM_TRANSPORT_CLIENT;
const getHistoryClient = () => HISTORY_CLIENT;
const getVendorAgreementClient = () => VENDOR_AGREEMENT_CLIENT;
const getROClient = () => RO_CLIENT;

class POQuaryParams {
  constructor({
    poNumber = undefined,
    poType = undefined,
    state = undefined,
    brand = undefined,
    buyerBillingId = undefined,
    sellerId = undefined,
    currency = undefined,
    pageNo = undefined,
    pageSize = undefined,
    sortBy = undefined,
    sortOrder = undefined,
    viewType = undefined,
    filterDateOn = undefined,
    startDate = undefined,
    endDate = undefined
  } = {}) {
    this.poNumber = poNumber;
    this.poType = poType;
    this.state = state;
    this.brand = brand;
    this.buyerBillingId = buyerBillingId;
    this.sellerId = sellerId;
    this.currency = currency;
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.sortBy = sortBy;
    this.sortOrder = sortOrder;
    this.viewType = viewType;
    this.filterDateOn = filterDateOn;
    this.startDate = startDate;
    this.endDate = endDate;
  }
}

function PORTableFormatter(input) {
  const tableView = { ...input };
  tableView.key = input?.id;
  tableView.brand = input?.brand?.name;
  tableView.vendor = input?.seller[0]?.name;
  tableView.buyer = input?.buyer[0]?.name;
  return tableView;
}

function getCurrencySymbol(currency) {
  const currencyMap = {
    INR: '₹',
    USD: '$'
  };
  return currencyMap[currency] ?? currency;
}

function getLabel(type) {
  const map = {
    VENDOR_REJECTED: 'VEN Rejected',
    FINANCE_APPROVAL_PENDING: 'FIN Pending',
    PLANNING_REJECTED: 'PL Rejected',
    CANCELLED: 'Cancelled',
    NEW: 'New',
    PLANNING_APPROVAL_PENDING: 'PL Pending',
    FINANCE_REJECTED: 'FIN Rejected',
    VENDOR_APPROVAL_PENDING: 'VEN Pending',
    ALL: 'All',
    IN_PROGRESS: 'In Progress',
    CLOSED: 'Closed',
    OPEN: 'Open',
    ALLOCATION_PENDING: 'Allocation Pending',
    REJECTED: 'Rejected',
    APPROVAL_PENDING: 'Approval Pending',
    ASN_REJECTED: 'ASN Rejected',
    ASN_APPROVED: 'ASN Approved',
    PACKED: 'Packed',
    DISPATCHED: 'Dispatched',
    DELIVERED: 'Delivered',
    INTERNATIONAL_GRN: 'FG International',
    DOMESTIC_GRN: 'FG Domestic',
    DOMESTIC_PO: 'FG Domestic',
    INTERNATIONAL_PO: 'FG International',
    DOMESTIC_ONLINE: 'Domestic Online',
    DOMESTIC_OFFLINE: 'Domestic Offline',
    EXPORT_ONLINE: 'Export Online',
    INTERNATIONAL_STOCK_TRANSFER: 'International Stock Transfer',
    PENDING: 'Pending',
    SINGLE_LOCATION: 'Single Location',
    MULTI_LOCATION: 'Multiple Location',
    APPROVED: 'Approved',
    PENDING_REVIEW: 'Pending Review',
    COMPLETED: 'Completed',
    CREATED: 'Created',
    VIRTUAL: 'Virtual',
    PHYSICAL: 'Physical',
    STOCK_TRANSFER: 'Stock Transfer',
    DOCUMENT_GENERATION: 'Generated',
    DOCUMENT_UPLOAD: 'Upload',
    GENERATE_TAX_INVOICE: 'Tax Invoice',
    SO_EINVOICE_GENERATE: 'E-Invoice',
    SO_DELIVERY_CHALLAN_GENERATE: 'Delivery Challan',
    SO_EWAYBILL_GENERATE: 'E-Way Bill',
    INTERNAL_STOCK_TRANSFER: 'Internal Stock Transfer',
    SAME_LOCATION_STOCK_TRANSFER: 'Same Location Internal Stock Transfer',
    FIN_ON_HOLD: 'Fin On Hold',
    OPS_ON_HOLD: 'Ops On Hold',
    FIN_APPROVAL_PENDING: 'Fin Approval Pending',
    OPS_APPROVAL_PENDING: 'Ops Approval Pending',
    FIN_REJECTED: 'Fin Rejected',
    OPS_REJECTED: 'Ops Rejected',
    INTERNATIONAL_PO_DIRECT_SHIPPING: 'Direct Shipping',
    INTERNATIONAL_PO_WH_SHIPPING: 'Warehouse Shipping',
    DOMESTIC_PO_DIRECT_SHIPPING: 'Direct Shipping',
    DOMESTIC_PO_WH_SHIPPING: 'Warehouse Shipping',
    MENSA: 'Mensa',
    VENDOR: 'Vendor',
    LOST: 'Lost',
    'refurbish-internal': 'Refurbish Internal',
    'refurbish-external': 'Refurbish External',
    SUCCESSFUL: 'Approved',
    DISPOSED: 'Disposed',
    PARTIAL_RTO: 'Partial RTO',
    QC_FAIL: 'QC Fail',
    QC_PASS: 'QC Pass',
    REVERSE_FBA: 'Reverse FBA',
    REVERSE_FBF: 'Reverse FBF',
    INTER_ENTITY_STOCK_TRANSFER: 'Inter Entity Stock Transfer',
    LIQUIDATION: 'Liquidation',
    DOMESTIC_ONLINE_EXCESS: 'Domestic Online Excess',
    REFURBISH: 'Refurbish',
    REFURBISH_INTERNAL: 'Refurbish Internal',
    REFURBISH_EXTERNAL: 'Refurbish External',
    GENERATED: 'Generated',
    CRN_GENERATED: 'CRN Generated',
    CANCELLED: 'Cancelled',
    MDM_SKU_TP_CREATE: 'Create',
    MDM_SKU_TP_UPDATE: 'Update',
    EPOD_VALIDATION: 'EPOD Validation',
    VALIDATED: 'Validated',
    VALIDATION_PENDING: 'Validation Pending',
    NO_DISCREPANCY_NO_CLAIM: 'No Discrepancy - No Claim',
    DISCREPANCY_NO_CLAIM: 'Discrepancy - No Claim',
    DISCREPANCY_CLAIM_TO_BE_RAISED: 'Discrepancy - Claim to be Raised'
  };
  return map?.[type] ?? type;
}

function getDateFromISO(date) {
  if (!date) return '-';
  return moment(date).format('DD MMM YYYY');
}

function GetDateTimeFromISO(date) {
  if (!date) return '-';
  return moment(date).format('DD MMM YYYY, h:mm a');
}

function GetRequestMapping(field) {
  // const map = {
  //   po_type: 'po_type',
  //   buyer: 'buyer_billing_id',
  //   seller: 'seller_id',
  //   po_number: 'po_number',
  //   search_number: 'search_number'
  // };
  // const ret = map[field] ? map[field] : field;
  return field;
}

const getBulkUploadLink = (data) => {
  if (!data) return null;
  if (typeof data === 'string') return data;
  return data.link || data.file_url || data.url || null;
};

const normalizeBulkUploadValidationResult = (data) => {
  if (!data) return {};
  if (typeof data === 'string') return { link: data };
  return {
    ...data,
    link: getBulkUploadLink(data)
  };
};

const getFilenameFromHeaders = (headers, fallback, url) => {
  const disposition = headers?.['content-disposition'] || headers?.['Content-Disposition'];
  if (disposition) {
    const utf8Match = disposition.match(/filename\*=UTF-8''([^;\n]+)/i);
    if (utf8Match) {
      return decodeURIComponent(utf8Match[1]);
    }
    const match = disposition.match(/filename="?([^";\n]+)"?/i);
    if (match) {
      return match[1];
    }
  }

  const urlFileName = url?.split('/')?.pop()?.split('?')[0];
  return urlFileName || fallback;
};

const triggerBlobDownload = (blob, fileName) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(objectUrl);
};

const isOfficeOpenXmlBlob = async (blob) => {
  if (!blob) return false;
  const header = await blob.slice(0, 4).arrayBuffer();
  const bytes = new Uint8Array(header);
  return bytes[0] === 0x50 && bytes[1] === 0x4b && bytes[2] === 0x03 && bytes[3] === 0x04;
};

const resolveDownloadFilename = async (blob, headers, defaultFileName, url) => {
  let fileName = getFilenameFromHeaders(headers, defaultFileName, url);

  if (await isOfficeOpenXmlBlob(blob)) {
    if (fileName.toLowerCase().endsWith('.csv')) {
      return fileName.replace(/\.csv$/i, '.xlsx');
    }
    if (!/\.xlsx$/i.test(fileName)) {
      return `${fileName.replace(/\.[^.]+$/, '') || 'download'}.xlsx`;
    }
  }

  return fileName;
};

const downloadTextAsFile = (content, fileName, mimeType = 'text/plain;charset=utf-8;') => {
  const blob = new Blob(['\uFEFF', content], { type: mimeType });
  triggerBlobDownload(blob, fileName);
};

const downloadFileFromUrl = async (url, defaultFileName) => {
  const response = await axios.get(url, { responseType: 'blob' });
  const fileName = await resolveDownloadFilename(response.data, response.headers, defaultFileName, url);
  triggerBlobDownload(response.data, fileName);
};

const downloadBulkSampleFile = async (endpoint, params, defaultFileName) => {
  const response = await getResponse(endpoint, params, null, { responseType: 'blob' }, true);
  const contentType = response.headers['content-type'] || response.headers['Content-Type'] || '';

  if (contentType.includes('application/json')) {
    const jsonText = await response.data.text();
    const json = JSON.parse(jsonText);
    const fileUrl = getBulkUploadLink(json.data);

    if (!fileUrl) {
      throw new Error('Sample file URL not found');
    }

    await downloadFileFromUrl(fileUrl, defaultFileName);
    return;
  }

  const fileName = await resolveDownloadFilename(response.data, response.headers, defaultFileName);
  triggerBlobDownload(response.data, fileName);
};

function DownloadViaLink(link, fileName) {
  const resolvedLink = getBulkUploadLink(link) || link;
  if (!resolvedLink) return;

  if (resolvedLink.startsWith('http://') || resolvedLink.startsWith('https://')) {
    downloadFileFromUrl(resolvedLink, fileName || 'download').catch(() => {
      window.open(resolvedLink, '_blank');
    });
    return;
  }

  const element = document.createElement('a');
  element.href = resolvedLink;
  element.setAttribute('download', fileName);
  element.click();
}

/**
 *
 * @param {string} state - state ex. PL_REJECTED, NEW
 * @returns - color
 */
const getColor = (state) => {
  const colorMap = {
    OPEN: 'green',
    IN_PROGRESS: 'green',
    PENDING: 'orange',
    REJECTED: 'magenta',
    CLOSED: '',
    NEW: 'geekblue',
    APPROVED: 'green',
    PENDING_REVIEW: 'orange',
    COMPLETED: 'green',
    CANCELLED: 'red',
    CREATED: 'geekblue',
    DELIVERED: 'green',
    PACKED: 'geekblue',
    DISPATCHED: 'gold',
    VIRTUAL: 'purple',
    PHYSICAL: 'orange',
    SUCCESSFUL: 'green',
    VALIDATED: 'green'
  };

  if (state?.includes(['REJECTED']) || state?.includes(['PO_REJECTION'])) {
    return colorMap.REJECTED;
  }
  if (state?.includes('PENDING')) return colorMap.PENDING;
  if (state?.includes('APPROVED')) return colorMap.APPROVED;
  if (state?.includes('HOLD')) return colorMap.REJECTED;
  return colorMap[state] ? colorMap[state] : null;
};

function getAddressFromEntityAddress(entity, showWms = true) {
  if (!entity) return '-';
  const facility = entity?.facility || { facility_code: entity?.facility_code, wms: entity?.wms };
  const address = [
    ...(showWms && facility?.wms && facility?.facility_code ? [`${facility?.wms} - ${facility?.facility_code}`] : []),
    entity?.nickname,
    entity?.first_line || entity?.firstLine,
    entity?.second_line || entity?.secondLine,
    entity?.city,
    entity?.state,
    entity?.country,
    entity?.zipcode
  ];
  return address?.filter((value) => !!value).join(', ');
}
/**
 *
 * @param {string} field - type of field
 * return {integer} - width of search input
 */
function GetSearchWidth(field) {
  const searchWidthMap = {
    po_number: 200,
    search_number: 300,
    invoice_number: 200,
    asn_number: 200,
    grn_number: 200,
    so_number: 200
  };
  return searchWidthMap[field] ?? 160;
}

function getError(error) {
  if (error?.response?.status === 403) {
    window.location.href = '/403';
  }
  return error?.response?.data?.status?.statusMessage ? error?.response?.data?.status?.statusMessage : error.message;
}

const GetSentenceCase = (string) => {
  const lowerCaseStr = string?.toLowerCase();
  return `${lowerCaseStr?.[0]?.toUpperCase()}${lowerCaseStr?.substring(1)}`;
};

const GetFileNameFromType = (type) =>
  type
    ?.split('_')
    ?.map((str) => GetSentenceCase(str))
    ?.join(' ');

const GetFileTypeLabel = (type) => {
  const fileTypeLabels = {
    'application/pdf': 'PDF',
    'text/csv': 'CSV',
    'text/csv, application/pdf': 'PDF or CSV'
  };

  return fileTypeLabels[type];
};

function GetFileLabel(fileType) {
  const fileLabelMap = {
    PURCHASE_INVOICE: 'Purchase Invoice',
    ASN_PACKING_LIST: 'Packing List',
    MRP_TAG: 'MRP Tags',
    CARTON_MARKINGS: 'Carton Markings',
    PO_SKU_MAPPING: 'Current File',
    GRN_PURCHASE_INVOICE: 'Purchase Invoice',
    GRN_EWAY_BILL: 'E-way Bill',
    GRN_PACKING_LIST: 'Packing List',
    GRN_LORRY_RECEIPT: 'Lorry Receipt',
    ASN_EI_PACKING_LIST: 'Export Invoice Packing List',
    ASN_EXPORT_INVOICE: 'Export Invoice',
    SKU_LIST: 'SKU List',
    PLATFORM_FILE: 'Platform File'
  };
  return fileLabelMap[fileType] ?? fileType;
}

function DownloadBlobData(data, fileName) {
  const fileURL = window.URL.createObjectURL(data);
  const alink = document.createElement('a');
  alink.href = fileURL;
  alink.download = `${fileName || 'newAsnData'}.zip`;
  alink.click();
}

function DownloadPdfBlob(data, fileName) {
  const fileURL = window.URL.createObjectURL(data);
  const alink = document.createElement('a');
  alink.href = fileURL;
  alink.download = `${fileName}.pdf`;
  alink.click();
}

async function DownloadPO(id, fileName, grace) {
  const res = await getPOClient().purchaseOrderExportpdfIdGet(id, true, grace, {
    responseType: 'blob'
  });
  DownloadPdfBlob(res.data, fileName);
}

async function DownloadPOCsv(id, fileName, grace, type) {
  const res = await getPOClient().purchaseOrderIdExportCsvGet(
    id,
    grace,
    {
      responseType: 'blob'
    },
    type
  );
  const fileURL = window.URL.createObjectURL(res.data);
  const alink = document.createElement('a');
  alink.href = fileURL;
  alink.download = `${fileName}.csv`;
  alink.click();
}

const getFormattedAmount = (currency, amount) => {
  if (!amount && amount !== 0) return '-';

  return amount?.toLocaleString('en-IN', {
    style: 'currency',
    currency: currency || 'INR'
  });
};

const getFormattedNumber = (value) => {
  if (!value) return '-';

  return value?.toLocaleString('en-IN');
};

const validator = (file, accept = '') => {
  const acceptedTypes = accept.split(',');
  const uploadedFileType = file.type;
  const uploadedFileExtension = uploadedFileType.split('/').pop();
  let isCorrectFormat = false;
  for (let i = 0; i < acceptedTypes.length; i += 1) {
    const acceptedType = acceptedTypes[i].trim();
    if (acceptedType === uploadedFileType || acceptedType === `.${uploadedFileExtension}`) {
      isCorrectFormat = true;
    }
  }

  const acceptedTypesStr = [...new Set(acceptedTypes.map((type) => Constants.FILE_TYPE_FOR_ERROR[type]))].join(', ');
  if (accept && !isCorrectFormat) {
    throw new Error(`You can only upload ${acceptedTypesStr} file`);
  }
  const isLt5M = file.size / 1024 / 1024 < 5;
  if (!isLt5M) {
    throw new Error('File must be smaller than 5MB');
  }
  return isCorrectFormat && isLt5M;
};

/**
 *
 * @param {*} file
 * @param {array} extension - ['application/pdf', 'image/jpg', 'text/csv']
 * @returns
 */
const FileTypeValidator = (file, extension) => {
  if (extension) {
    if (!extension.includes(file.type)) {
      const errorMessage = `File should be in ${extension
        .reduce((acc, current) => `${acc}, ${current.split('/')[1]}`, '')
        .substring(1)} format`;
      return { success: false, errorMessage };
    }
  }
  return { success: true };
};

const GetReasonBannerTitle = (commentType) => {
  if (!commentType) return;
  const reasonArray = commentType?.split('_');
  const typeMap = {
    ASN: 'ASN',
    PO: 'Purchase Order',
    GRN: 'GRN'
  };
  const reasonMap = {
    CANCELLED: 'Cancelled',
    REJECTION: 'Rejected'
  };

  const getReason = (reason) => {
    if (reason.includes('CANCELLED')) return 'CANCELLED';
    if (reason.includes('REJECTION')) return 'REJECTION';
  };
  return `${typeMap[reasonArray[0]]} ${reasonMap[getReason(commentType)]}`;
};

const GetDownloadButtonLabel = (variant) => {
  if (!variant) return;
  const reasonMap = {
    cancelled: 'Cancellation',
    rejected: 'Rejection'
  };
  if (reasonMap?.[variant]) {
    return `Download SKU wise ${reasonMap[variant]} Reasons`;
  }
  return null;
};

const GetReasonBannerVariant = (commentType) => {
  if (!commentType) return;
  const reasonArray = commentType?.split('_');
  const reasonMap = {
    CANCELLED: 'cancelled',
    REJECTION: 'rejected'
  };

  const getReason = (reason) => {
    if (reason.includes('CANCELLED')) return 'CANCELLED';
    if (reason.includes('REJECTION')) return 'REJECTION';
  };

  if (reasonMap?.[getReason(commentType)]) return reasonMap?.[getReason(commentType)];
  return null;
};

const FlatFiltersPostBody = (data) => {
  const flat = {};
  for (const key in data) {
    // console.log(key, data[key]);
    if (Array.isArray(data[key])) {
      flat[key] = data[key].map((e) => (e?.id ? e.id : e));
    } else {
      flat[key] = data[key];
    }
  }
  return flat;
};

const RemoveFieldFromObj = (data, key) => {
  const temp = { ...data, [key]: '' };
  delete temp[key];
  return temp;
};

const DuplicateRemover = (data) => {
  const uniq = [...new Set(data)];
  return uniq;
};

/**
 *
 * @param {object} obj
 * @returns {object}
 */
const NullRemover = (obj) => {
  let values = {};
  for (const val in obj) {
    if (obj[val] && obj[val] !== '') values[val] = obj[val];
  }

  return values;
};

const getTypeObj = (href, type) => Constants?.[type].find((item) => item?.href === href);

const getLabelAndValues = (field, options) => options?.[field]?.values.map((item) => ({ label: item, value: item }));

const sort = (a, b) => {
  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
};

const filterOptionFn = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

const getTitleCase = (s) => s.replace(/^_*(.)|_+(.)/g, (s, c, d) => (c ? c.toUpperCase() : ` ${d.toUpperCase()}`));

const localStorageUtility = {
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      throw new Error('Error saving to localStorage');
    }
  },

  getItem: (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      throw new Error('Error reading from localStorage');
    }
  },

  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      throw new Error('Error removing from localStorage');
    }
  },

  clear: () => {
    try {
      localStorage.clear();
    } catch (error) {
      throw new Error('Error clearing localStorage');
    }
  },

  onLogout: () => {
    localStorageUtility.removeItem('showAgreement');
    localStorage.removeItem('token');
    clearCorrelationId();
  }
};

const createLink = (input) => {
  if (input && !input.startsWith('https://')) return `https://${input}`;
  return input;
};

const LINKS = {
  returnOrder: {
    path: '/sales/return',
    create: {
      domesticOnline: '/sales/ro/create/DOMESTIC_ONLINE',
      domesticOffline: '/sales/ro/create/DOMESTIC_OFFLINE'
    },
    bulkUploader: {
      basePath: '/bulkuploader/ro-create',
      domesticOffline: `/bulkuploader/ro-create/DOMESTIC_OFFLINE`,
      domesticOnline: '/bulkuploader/ro-create/DOMESTIC_ONLINE',
      refurbishInternal: '/bulkuploader/ro-create/refurbish-internal',
      refurbishExternal: '/bulkuploader/ro-create/refurbish-external',
      sendForApproval: '/bulkuploader/ro/send_for_approval',
      approve: '/bulkuploader/ro/approve',
      markAsOpen: '/bulkuploader/ro/mark_as_open',
      dispatch: '/bulkuploader/ro/dispatch',
      deliver: '/bulkuploader/ro/deliver',
      inwardOrderSingle: '/bulkuploader/ro/inward_order_single',
      inwardOrderGroup: '/bulkuploader/ro/inward_order_group'
    }
  }
};

const getFileExtension = (name) => {
  const nameArray = name.split('.');
  return nameArray[nameArray.length - 1];
};

const getLatestLrNumber = (lrNumber) => {
  if (!lrNumber) return '';
  if (typeof lrNumber !== 'string') return lrNumber;

  const parts = lrNumber
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);

  return parts[parts.length - 1] || lrNumber;
};

const delay = (ms, onSuccess, onError) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        if (onSuccess) onSuccess();
        resolve();
      } catch (error) {
        if (onError) onError(error);
        reject(error);
      }
    }, ms);
  });
};

/**
 * @summary throws error, use to upload file for s3 uploader
 * @param {string} objectKey : s3 route
 * @param {object} file : file object
 * @param {object} loader
 * @param {Function} loader.start start of loader
 * @param {Function} loader.stop end of loader
 * @param {Function} onSuccess
 * @param {Function} onError
 * @returns {Boolean}
 */

const handleS3Upload = (objectKey, file, loader, onSuccess, onError) => {
  const path = apiConfig.return.preSignedUrl;
  const params = { object_key: objectKey };

  if (loader?.start) loader.start();

  CallApi(
    path,
    params,
    null,
    null,
    async (res) => {
      try {
        const response = await axios.put(res, file, {
          headers: {
            'Content-Type': file.type
          }
        });
        if (response.status === 200) {
          onSuccess(res);
          if (loader?.stop) loader?.stop;
        }
      } catch {
        throw new Error('Error while uploading to s3!');
      }
    },
    (error) => {
      onError(error);
      if (loader?.stop) loader?.stop;
    }
  );
  return false;
};

// message show function
// uses App api of antd
const showErrorMessage = (error) => showMessage().error(getError(error));

const downloadfileFromString = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const getTypeBasedSalesModelForSO = (type, SalesModel) => {
  const salesModelMap = {
    INTERNAL_STOCK_TRANSFER: {
      FBA: 'REVERSE_FBA',
      FBF: 'REVERSE_FBF'
    }
  };

  if (salesModelMap[type] && salesModelMap[type][SalesModel]) {
    return getLabel(salesModelMap[type][SalesModel]);
  }
  return getLabel(SalesModel);
};

const convertToSnakeCase = (data) => {
  if (Array.isArray(data)) {
    return data.map((item) => convertToSnakeCase(item));
  }

  if (data !== null && typeof data === 'object' && !(data instanceof Date)) {
    const snakeCaseData = {};
    for (const key in data) {
      const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
      snakeCaseData[snakeKey] = convertToSnakeCase(data[key]);
    }
    return snakeCaseData;
  }

  return data;
};

const convertToCamelCase = (data) => {
  if (Array.isArray(data)) {
    return data.map((item) => convertToCamelCase(item));
  }

  if (data !== null && typeof data === 'object' && !(data instanceof Date)) {
    const camelCaseData = {};
    for (const key in data) {
      const camelKey = key.replace(/(_[a-z])/g, (match) => match[1].toUpperCase());
      camelCaseData[camelKey] = convertToCamelCase(data[key]);
    }
    return camelCaseData;
  }

  return data;
};

const convertObjKeysToSnakeCase = (data) => {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return data;
  }

  const snakeCaseData = {};
  for (const key in data) {
    const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
    snakeCaseData[snakeKey] = data[key];
  }
  return snakeCaseData;
};

const convertObjKeysToCamelCase = (data) => {
  if (!data) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map((item) => convertObjKeysToCamelCase(item));
  }

  if (typeof data !== 'object') {
    return data;
  }

  const camelCaseData = {};
  for (const key in data) {
    const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    camelCaseData[camelKey] = convertObjKeysToCamelCase(data[key]);
  }
  return camelCaseData;
};

const screamingSnakeCaseToTitleCase = (str) => {
  if (!str) return '';
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

// Filter out inactive entities
const filterActiveEntities = (entities) => {
  if (!entities || !Array.isArray(entities)) return [];
  return entities.filter((entity) => !entity?.isInactive && !entity?.is_inactive);
};

const getMappedValueSafely = (map, key) => {
  return map[key] ?? key;
}

export {
  POQuaryParams,
  filterActiveEntities,
  getPOClient,
  getASNClient,
  getAttachmentClient,
  getCommentsClient,
  getGRNClient,
  getInternationalInventoryClient,
  getSalesPOClient,
  getSalesOrderClient,
  getSoGRNClient,
  PORTableFormatter,
  getCurrencySymbol,
  getLabel,
  getDateFromISO,
  GetDateTimeFromISO,
  GetRequestMapping,
  DownloadViaLink,
  downloadBulkSampleFile,
  downloadFileFromUrl,
  downloadTextAsFile,
  getBulkUploadLink,
  normalizeBulkUploadValidationResult,
  getColor,
  getAddressFromEntityAddress,
  getClearTaxInputClient,
  GetSearchWidth,
  getError,
  GetFileLabel,
  DownloadPO,
  DownloadPdfBlob,
  getFormattedAmount,
  getFormattedNumber,
  getMDMEntityClient,
  getMDMTermsAndConditions,
  getMDMBrandsClient,
  DownloadBlobData,
  DownloadPOCsv,
  FileTypeValidator,
  GetFileTypeLabel,
  validator,
  getMDMTransportClient,
  GetFileNameFromType,
  GetReasonBannerTitle,
  GetDownloadButtonLabel,
  GetReasonBannerVariant,
  FlatFiltersPostBody,
  RemoveFieldFromObj,
  DuplicateRemover,
  NullRemover,
  getTypeObj,
  getLabelAndValues,
  sort,
  filterOptionFn,
  getHistoryClient,
  getTitleCase,
  getVendorAgreementClient,
  localStorageUtility,
  getROClient,
  createLink,
  LINKS,
  getFileExtension,
  delay,
  handleS3Upload,
  showErrorMessage,
  downloadfileFromString,
  getTypeBasedSalesModelForSO,
  convertToSnakeCase,
  convertToCamelCase,
  convertObjKeysToSnakeCase,
  convertObjKeysToCamelCase,
  screamingSnakeCaseToTitleCase,
  getMappedValueSafely,
  getLatestLrNumber
};

const MERGED_ENTITIES = [
  'cephus brand technologies private limited',
  'helea technology private limited',
  'villain lifestyle private limited',
  'implexians eco solutions private limited',
  'archernar brand technologies private limited',
  'lepus brand technologies private limited',
  'pyxis brand technologies private limited'
];

export const isMergedEntity = (sellerName) => {
  // Check if feature is enabled via environment variable
  const isFeatureEnabled = process.env?.REACT_APP_SHOW_MERGED_ENTITY_NOTICE === 'true';
  
  if (!isFeatureEnabled) {
    return false;
  }
  
  return MERGED_ENTITIES.includes(sellerName?.trim()?.toLowerCase());
};
